// Category icon mapping
export const categoryIcons = {
    // Food & Dining
    'אוכל בעבודה': '🍱',
    'אוכל בעבודה	': '🍱', // with tab character
    'מזון ומצרכים': '🛒',
    'אוכל בחוץ ופנאי': '🍽️',
    'אוכל בחוץ': '🍴',
    
    // Housing & Utilities
    'דיור': '🏠',
    'תקשורת': '📱',
    'דירה גפן ניטרלי': '🏢',
    'דירה גפן הוצאות': '🏢',
    'משכנתא': '🏦',
    
    // Clothing & Personal
    'הלבשה והנעלה': '👕',
    'לובן': '🧺',
    'טיפוח וספורט': '💪',
    'בריאות': '🏥',
    
    // Education & Children
    'חינוך': '📚',
    'ילדים': '👶',
    
    // Finance & Banking
    'פעולות פיננסיות בנק': '🏦',
    'משכורת': '💰',
    'כרטיס אשראי': '💳',
    'מזומן': '💵',
    'פקדונות': '🏦',
    'שוק ההון': '📈',
    'השקעות': '💹',
    'משיכה כספומט': '🏧',
    
    // Transportation
    'תחבורה ציבורית': '🚌',
    'רכב': '🚗',
    'חניה': '🅿️',
    'דלק': '⛽',
    
    // Leisure & Entertainment
    'פנאי': '🎮',
    'חופשות בחו״ל': '✈️',
    'חופשות וטיולים בארץ': '🏖️',
    'שירותי מדיה': '📺',
    
    // Shopping & Gifts
    'אלקטרוניקה': '💻',
    'מתנות וימי הולדת': '🎁',
    'כלבו כללי': '🛍️',
    
    // Other
    'תרומות': '❤️',
    'טל עסק הוצאות': '💼',
    'מצריך בירור': '❓',
    'בדיקה': '🔍',
    'טסט': '🧪'
};

// Get icon for a category, with fallback
export const getCategoryIcon = (categoryName) => {
    if (!categoryName) return '📌';
    
    // Trim whitespace and try to find exact match
    const trimmedName = categoryName.trim();
    if (categoryIcons[trimmedName]) {
        return categoryIcons[trimmedName];
    }
    
    // Try original name
    if (categoryIcons[categoryName]) {
        return categoryIcons[categoryName];
    }
    
    // Default fallback
    return '📌';
};